import React from 'react';
import { useGlobal } from 'reactn';

const HoursColumnHeader = () => {
  const [config] = useGlobal('config');
  const showBillableHoursConfig = config['show-report-billable-hours'];
  const showBillableHours = showBillableHoursConfig === 'true' || showBillableHoursConfig === "1";

  return (
    <div>
      <div className="font-bold">Hours</div>
      {showBillableHours && (
        <div className="">(Billable/Non-Billable)</div>
      )}
    </div>
  );
};

export default HoursColumnHeader;